import React, { FC, ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useUserTheme } from './hooks';
import { createThemeConfig } from './utils';

interface AppThemeProviderProps {
    children: ReactNode;
}

const AppThemeProvider: FC<AppThemeProviderProps> = ({ children }) => {
    const { theme } = useUserTheme();
    const themeConfig = createThemeConfig(theme);

    return (
        <ThemeProvider theme={themeConfig}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default AppThemeProvider;
